<template>
  <div class="account">
    <h1 class="header">Profile</h1>

    <div class="profile">
      <img src="../assets/gravatar.png" alt />
    </div>

    <div class="info">
      <div class="email input-container">
        <input id="email" class="input" pattern=".+" required />
        <label class="label" for="email">Email</label>
      </div>
      <div class="password input-container">
        <input id="password" class="input" type="password" pattern=".+" required />
        <label class="label" for="password">Password</label>
      </div>
    </div>

    <section>
      <plaid-link
        env="development"
        publicKey="e5cd60adc22019365b0f178a4a1d8a"
        clientName="Test App"
        product="liabilities"
        v-bind="{ onSuccess }"
      ><img src="../assets/plaid-logo.png" alt=""></plaid-link>
      <button @click="logout">Logout</button>
    </section>
  </div>
</template>

<script>
import firebase from "firebase";
import PlaidLink from "vue-plaid-link";

export default {
  name: "account",
  components: {
    PlaidLink
  },
  props: ["api"],
  data() {
    return {};
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },
    onSuccess(token) {
      var getAccessToken = firebase.functions().httpsCallable("getAccessToken");
      getAccessToken({ public_token: token }).then(function(result) {
      });
    }
  }
};
</script>

<style lang="scss">
.account {
  .header {
    font-family: var(--sans);
    padding: 0 2rem;
  }

  .profile {
    text-align: center;
    img {
      border-radius: 50%;
      width: 10rem;
    }
  }

  .info {
    font-family: var(--mono);
    display: grid;
    padding: 0 2rem;

    .input-container{
          margin: 3rem 0;
    }

    .password {
      margin-top: 2rem;
    }
  }

  section{
    display: flex;

    .plaid-link-button{
      padding: 0.3rem;

      img{
        filter: invert(100%);
        width: 8rem;
      }
    }
    
  }
}
</style>
